import { createActions } from 'redux-actions';
import { request } from '../../services';

const {
  jobPaperworkTemplateCreateRequest,
  jobPaperworkTemplateCreateSuccess,
  jobPaperworkTemplateCreateFailure,
} = createActions({
  JOB_PAPERWORK_TEMPLATE_CREATE_SUCCESS: json => json.job_paperwork_template,
}, 'JOB_PAPERWORK_TEMPLATE_CREATE_REQUEST', 'JOB_PAPERWORK_TEMPLATE_CREATE_FAILURE');

export function jobPaperworkTemplateCreate(templateData) {
  return (dispatch) => {
    dispatch(jobPaperworkTemplateCreateRequest());
    return request(`phases/${templateData.phase_id}/job_paperwork_templates`, {
      method: 'POST',
      body: { job_paperwork_template: templateData },
    })
      .then(({ json }) => dispatch(jobPaperworkTemplateCreateSuccess(json)))
      .catch((error) => {
        dispatch(jobPaperworkTemplateCreateFailure(error));
        throw error;
      });
  };
}

export function requestJobPaperworkTemplates(phaseId) {
  return request(`phases/${phaseId}/job_paperwork_templates`)
    .then(({ json }) => ({
      templates: json.job_paperwork_templates || [],
      error: null,
    }))
    .catch(error => ({
      templates: [],
      error,
    }));
}



// WEBPACK FOOTER //
// ./client/app/shared/actionCreators/job_paperwork_templates.js